// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequireAuth_loaderScreen__eX8Sj {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--dylo-page-bg);
}

.RequireAuth_spinner__SM8Yo {
  width: 42px;
  height: 42px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: var(--dylo-teal-300);
  border-radius: 50%;
  animation: RequireAuth_ra-spin__1jKYH 0.75s linear infinite;
}

@keyframes RequireAuth_ra-spin__1jKYH {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/RequireAuth.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,2DAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".loaderScreen {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: var(--dylo-page-bg);\n}\n\n.spinner {\n  width: 42px;\n  height: 42px;\n  border: 3px solid rgba(255, 255, 255, 0.2);\n  border-top-color: var(--dylo-teal-300);\n  border-radius: 50%;\n  animation: ra-spin 0.75s linear infinite;\n}\n\n@keyframes ra-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderScreen": `RequireAuth_loaderScreen__eX8Sj`,
	"spinner": `RequireAuth_spinner__SM8Yo`,
	"ra-spin": `RequireAuth_ra-spin__1jKYH`
};
export default ___CSS_LOADER_EXPORT___;
